import { Component, Input } from '@angular/core';
import { SimpleTextNavItemConfig } from '../../gk-dynamic-navbar.model';
import { NavBaseComponent } from '../nav-base/nav-base.component';

@Component({
  selector: 'gk-nav-item-simple-text',
  templateUrl: './nav-item-simple-text.component.html',
  styleUrls: ['./nav-item-simple-text.component.scss'],
  standalone: false,
})
export class NavItemSimpleTextComponent extends NavBaseComponent {
  @Input()
  simpleTextNavItemConfig: SimpleTextNavItemConfig;
}
